import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { LocalOrderDeadline } from '@asm/features/quick-order/models/offline-reference-data.model';

@Injectable({ providedIn: 'root' })
export class OrderDeadlineRepository extends RepositoryBase<LocalOrderDeadline> {
  protected readonly KEY_PATH = 'order_deadlines';
}
